import { useStorage } from 'reactfire';
import { ref, getDownloadURL } from 'firebase/storage';
import { useState, useEffect } from 'react';

export default function usePublishedData(input) {
  const storage = useStorage();
  const [data, setData] = useState(null);
  useEffect(() => {

    const download = async () => {
      const file = ref(storage, 'groves.json')
      const grovesURL = await getDownloadURL(file)
      const response = await fetch(grovesURL);
      const data = await response.json();
      const parksById = {}
      data.parks.forEach(park => {
        parksById[park.id] = park
      })
      data.groves.forEach(grove => {
        grove['NO_ID_FIELD'] = grove.id
        if (grove.park && parksById[grove.park]) {
          grove.parkData = parksById[grove.park]
        }
      })
      window.groves = data
      setData(data);
    }
    download();
  }, [storage, input])

  return data

}
